import styled from "styled-components";

export const BtnRoomBookingSentWidgetStyled = styled.div``;
